export const BASE_IMAGE_URL = "http://api.cryptoindices.io";
export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 5 },
    md: { span: 5 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 19 },
    md: { span: 19 },
  },
};

export const currencyFormat = {
  style: "currency",
  currency: "USD",
};
